import React from "react";
import { TimerSection } from "../Timer";
import { useUserContext } from "../../../../utils/contexts/UserProvider";
import { isDevlopment } from "../../../../utils/env";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../atom/Button";
import { ROUTES } from "../../../../utils/consts/routes";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "@carbon/icons-react";

interface SummaryProps {
  title: string;
  showTimer?: boolean;
  hideUserData?: boolean;
  setIsCompleted?: React.Dispatch<React.SetStateAction<boolean>>;
  isResult?: boolean;
  isPractice?: boolean;
}

export const Header = ({
  title,
  showTimer,
  hideUserData,
  setIsCompleted,
  isResult,
  isPractice,
}: SummaryProps) => {
  const { user } = useUserContext();
  const isDev = isDevlopment();
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      className={`w-full flex justify-between items-center px-10 pt-6 pb-5 border-b border-b-gray-200 ${isResult ? "fixed z-[1000] bg-white h-[88px]" : "h-[80px]"}`}>
      {isDev && (
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-1 rounded-b-lg text-sm font-semibold">
          Development
        </div>
      )}
      {isResult ? (
        <Button
          type="tertiary"
          onClick={() => navigate(isPractice ? ROUTES.practice : ROUTES.dashboard)}
          label={t("Go Back")}
          leftIcon={<ArrowLeft size={24} />}
        />
      ) : (
        <p className="text-[20px] font-medium leading-[25.2px] tracking-[0.1px] text-black ">
          {title}
        </p>
      )}
      <div>
        <img src="/images/logo.svg" className={`h-[${isResult ? "24" : "20"}px]`} alt="" />
      </div>
      {!hideUserData && (
        <div className="flex justify-center items-center gap-x-8">
          {!hideUserData && (
            <p
              className={
                isResult
                  ? "text-[18px] font-medium  leading-[140%] tracking-[0.2px] text-black"
                  : "text-[16px] font-normal leading-[22.4px] tracking-[0.2px] text-black"
              }>
              {user?.first_name} {user?.last_name}
            </p>
          )}
          {showTimer && <TimerSection setIsTimerCompleted={setIsCompleted} />}
        </div>
      )}
    </div>
  );
};
